import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Container, Row, Col, Card, Form, Button, Alert } from 'react-bootstrap';
import { authService } from '../../services/authService';
const RECAPTCHA_SITE_KEY = '6Lfz5QwsAAAAAOAkHId4fBaVB01l-uovzxvltPs2';
// const TURNSTILE_SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY;  // РОЗКОМЕНТУВАТИ якщо треба captcha на login
const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [emailHoneypot, setEmailHoneypot] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  // const [turnstileLoaded, setTurnstileLoaded] = useState(false);  // РОЗКОМЕНТУВАТИ якщо треба Turnstile
  // const [turnstileWidgetId, setTurnstileWidgetId] = useState(null);  // РОЗКОМЕНТУВАТИ якщо треба Turnstile
  const navigate = useNavigate();
  useEffect(() => {
    const recaptchaScript = document.createElement('script');
    recaptchaScript.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`;
    recaptchaScript.async = true;
    document.body.appendChild(recaptchaScript);
    /* РОЗКОМЕНТУВАТИ ЯКЩО ТРЕБА TURNSTILE НА LOGIN
    const turnstileScript = document.createElement('script');
    turnstileScript.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?onload=onTurnstileLoadLogin';
    turnstileScript.async = true;
    turnstileScript.defer = true;
    window.onTurnstileLoadLogin = () => {
      setTurnstileLoaded(true);
    };
    document.body.appendChild(turnstileScript);
    */
    return () => {
      if (document.body.contains(recaptchaScript)) {
        document.body.removeChild(recaptchaScript);
      }
      /* РОЗКОМЕНТУВАТИ ЯКЩО ТРЕБА TURNSTILE
      if (document.body.contains(turnstileScript)) {
        document.body.removeChild(turnstileScript);
      }
      delete window.onTurnstileLoadLogin;
      */
    };
  }, []);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      /* РОЗКОМЕНТУВАТИ ЯКЩО ТРЕБА TURNSTILE НА LOGIN
      if (!turnstileLoaded || !window.turnstile) {
        throw new Error('Turnstile not loaded. Please refresh the page.');
      }
      const turnstileToken = await new Promise((resolve, reject) => {
        const timeout = setTimeout(() => {
          reject(new Error('Turnstile timeout'));
        }, 10000);
        if (turnstileWidgetId !== null) {
          window.turnstile.reset(turnstileWidgetId);
        }
        const widgetId = window.turnstile.render('#turnstile-widget-login', {
          sitekey: TURNSTILE_SITE_KEY,
          callback: (token) => {
            clearTimeout(timeout);
            resolve(token);
          },
          'error-callback': (error) => {
            clearTimeout(timeout);
            reject(new Error('Turnstile verification failed'));
          },
          'timeout-callback': () => {
            clearTimeout(timeout);
            reject(new Error('Turnstile timeout'));
          }
        });
        setTurnstileWidgetId(widgetId);
      });
      */
      /* РОЗКОМЕНТУВАТИ ЯКЩО ТРЕБА RECAPTCHA НА LOGIN
      if (!window.grecaptcha || !window.grecaptcha.execute) {
        throw new Error('reCAPTCHA not loaded. Please refresh the page.');
      }
      const recaptchaToken = await window.grecaptcha.execute(RECAPTCHA_SITE_KEY, {
        action: 'login'
      });
      */
      const data = await authService.login(
        email, 
        password
        // emailHoneypot,  // РОЗКОМЕНТУВАТИ якщо треба honeypot
        // recaptchaToken,  // РОЗКОМЕНТУВАТИ якщо треба reCAPTCHA
        // turnstileToken  // РОЗКОМЕНТУВАТИ якщо треба Turnstile
      );
      if (data.token) {
        localStorage.setItem('token', data.token);
        //localStorage.setItem('user', JSON.stringify(data.user));
        localStorage.setItem('user', JSON.stringify(data.client));
        navigate('/dashboard');
      }
    } catch (err) {
      const errorMsg = err.response?.data?.message || err.message || 'Login failed';
      setError(errorMsg);
      /* РОЗКОМЕНТУВАТИ ЯКЩО ТРЕБА TURNSTILE
      if (turnstileWidgetId !== null && window.turnstile) {
        window.turnstile.reset(turnstileWidgetId);
      }
      */
    } finally {
      setLoading(false);
    }
  };
  return (
    <Container className="mt-5">
      <Row className="justify-content-center">
        <Col md={6} lg={4}>
          <Card className="shadow">
            <Card.Body>
              <h2 className="text-center mb-4">Login</h2>
              {error && <Alert variant="danger">{error}</Alert>}
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label>Email/Login</Form.Label>
                  <Form.Control 
                    type="text" 
                    value={email} 
                    onChange={(e) => setEmail(e.target.value)} 
                    required 
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Password</Form.Label>
                  <Form.Control 
                    type="password" 
                    value={password} 
                    onChange={(e) => setPassword(e.target.value)} 
                    required 
                  />
                </Form.Group>
                {/* РОЗКОМЕНТУВАТИ ЯКЩО ТРЕБА HONEYPOT
                <Form.Group className="mb-3" style={{ position: 'absolute', left: '-9999px' }}>
                  <Form.Label>Email (do not fill)</Form.Label>
                  <Form.Control 
                    type="email" 
                    value={emailHoneypot} 
                    onChange={(e) => setEmailHoneypot(e.target.value)} 
                    tabIndex="-1" 
                    autoComplete="off" 
                  />
                </Form.Group>
                */}
                {/* РОЗКОМЕНТУВАТИ ЯКЩО ТРЕБА TURNSTILE
                <div id="turnstile-widget-login"></div>
                */}
                <Button 
                  type="submit" 
                  variant="primary" 
                  className="w-100" 
                  disabled={loading}
                >
                  {loading ? 'Loading...' : 'Login'}
                </Button>
              </Form>
              <div className="text-center mt-3">
                <Link to="/forgot-password">Forgot Password?</Link>
                <div className="mt-2">Don't have an account? <Link to="/register">Register</Link></div>
              </div>
              <div className="mt-3 text-muted small text-center">
                This site is protected by reCAPTCHA and the Google{' '}
                <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a> and{' '}
                <a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer">Terms of Service</a> apply.
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};
export default Login;